import { UserCheck, FileCheck, ShieldCheck, Gift } from 'lucide-react';

export const ConfidenceBanner = () => {
  const items = [
    { 
      icon: Gift, 
      title: "Accès 100% gratuit",
      description: "Création de compte sans frais, sans abonnement"
    },
    { 
      icon: UserCheck, 
      title: "Interlocuteur fiscal dédié",
      description: "Un conseiller vous accompagne personnellement jusqu'à la réception de votre avis de taxation"
    },
    { 
      icon: FileCheck, 
      title: "Déclaration encadrée",
      description: "Chaque déclaration est vérifiée par un expert avant envoi aux autorités fiscales"
    },
    { 
      icon: ShieldCheck, 
      title: "Plateforme sécurisée",
      description: "Vos données sont hébergées en Suisse avec chiffrement et authentification sécurisée"
    },
  ];

  return (
    <section 
      className="py-3 md:py-5 bg-white/80 backdrop-blur-sm"
      style={{ boxShadow: '0 2px 12px -2px rgba(11, 59, 50, 0.04)' }}
    >
      <div className="container-custom px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-6">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <div 
                key={index} 
                className="flex flex-col items-center text-center py-1.5 md:py-2 rounded-xl transition-all duration-300 hover:bg-green-pastel/30 hover:scale-[1.02] cursor-default"
              >
                <Icon className="w-5 h-5 md:w-6 md:h-6 text-green-secondary mb-1.5 md:mb-2 transition-transform duration-300 group-hover:scale-110" aria-hidden="true" />
                <p className="font-semibold text-green-primary text-sm md:text-base">
                  {item.title}
                </p>
                <p className="text-gray-600 text-[11px] md:text-sm mt-0.5 leading-snug">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
